module.exports = __webpack_public_path__ + "media/images/pokerroom/partypoker/step2-pict01-0a4b5b27b110a3ac168d1422ec1cde8c.jpg";